import React from "react";
import "./App.css";
import { Routes, Route } from 'react-router-dom';
import Homepage from "./pages/unauthorized/homepage/Homepage";
import LoginFormPage from "./pages/unauthorized/loginForm/LoginInForm";
import AdminPage from "./pages/authorized/adminPage/AdminPage";
import CategoryPage from "./pages/authorized/dashboard/CategoryPage";
import DashboardPage from "./pages/authorized/dashboard/DashboardPage";
import Schedule from "./pages/authorized/schedule/schedule";
import ProtectedRoute from "./routes/ProtectedRoute";
import { VideosPanel } from "./pages/authorized/adminPage/videosPanel/VideosPanel";
import WebAccessibility from "./pages/unauthorized/webAccessibility/WebAccessibility";
import TeachersProfilePanel from "./pages/authorized/adminPage/teachersProfilePanel/TeachersProfilePanel";
import HomeContentPanel from "./pages/authorized/adminPage/homeContentPanel/HomeContentPanel";
import Recommendations from "./pages/unauthorized/recommendations/Recommendations";
import Profiles from "./pages/unauthorized/profiles/profiles";
import LessonStructure from "./pages/unauthorized/lessonStructure/LessonStructure";
import LangindPage from "./pages/unauthorized/landingPage/LandingPage";


const Navigation = () => {
  return (
    <Routes>
      <Route path="/" element={<Homepage />} />
      <Route path="/landingPage" element={<LangindPage />}/>
      <Route path="/sign-in" element={<LoginFormPage />} />
      <Route path="/accessibility" element={<WebAccessibility />} />
      <Route path="/recommendations" element={<Recommendations />} />
      <Route path="/teachers" element={<Profiles />} />
      <Route path="/syllabus" element={<LessonStructure />} />
      <Route path="/teachersLanding" element={<Profiles />} />
      <Route path="/recommendationsLanding" element={<Recommendations />} />
      <Route 
        path="/dashboard" 
        element={
          <ProtectedRoute allowedRoles={['premium', 'student', 'teacher']}>
            <DashboardPage />
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/category/:category" 
        element={
          <ProtectedRoute allowedRoles={['premium', 'student', 'teacher']}>
            <CategoryPage />
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/schedule" 
        element={
          <ProtectedRoute allowedRoles={['premium', 'teacher']}>
            <Schedule />
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/admin" 
        element={
          <ProtectedRoute allowedAuthorizations={['admin']}>
            <AdminPage />
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/admin/videos" 
        element={
          <ProtectedRoute allowedAuthorizations={['admin']}>
            <VideosPanel />
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/admin/teachers" 
        element={
          <ProtectedRoute allowedAuthorizations={['admin']}>
            <TeachersProfilePanel />
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/admin/home" 
        element={
          <ProtectedRoute allowedAuthorizations={['admin']}>
            <HomeContentPanel />
          </ProtectedRoute>
        } 
      />
    </Routes>
  );
};

export default Navigation;
